import React from 'react';
import GridHeaderCell from './GridHeaderCell';

const GridHeader = (props) => {

  const handleHeaderClick = (columnKey) => {
    if (props.onSort && props.columns[columnKey].sortable) {
      const direction =
        props.sortConfig.key === columnKey && props.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
      props.onSort({ key: columnKey, direction });
    }
  };

  return (
    <thead ref={props.theadRef}>
      <tr>{props.columns.map((column, index) => <GridHeaderCell onClick={handleHeaderClick} columnId={index} column={column}
        key={index} row={props.row} sortConfig={props.sortConfig} />)}</tr>
    </thead>
  );
};

export default GridHeader;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridHeader.jsx